export default {
  title: {
    text: "负极材料价格趋势",
  },
  legend: {
    data: ["人工石墨", "天然石墨"],
    top: 100,
  },
  grid: {
    top: 240,
  },
  tooltip: {
    trigger: "axis",
  },
  xAxis: {
    name: "时间",
    type: "category",
    axisLabel: {
      show: true,
      textStyle: {
        color: "white",
        fontSize: 30,
      },
    },
    data: ["2017", "Q2", "Q3", "Q4", "Q1", "Q2", "Q3", "Q4", "2019"],
  },
  yAxis: {
    name: "价格 万元/吨",
    type: "value",
    interval: 2,
  },
  series: [
    {
      name: "人工石墨",
      type: "line",
      itemStyle: {
        normal: {
          borderWidth: 2,
        },
      },
      lineStyle: {
        normal: {
          width: 8,
        },
      },
      symbolSize: 20,
      smooth: true,
      data: [
        4.252,
        4.2362,
        5.5118,
        5.6221,
        5.0866,
        5.0078,
        4.9134,
        5.0236,
        4.9134,
      ],
    },
    {
      name: "天然石墨",
      type: "line",
      smooth: true,
      itemStyle: {
        normal: {
          borderWidth: 2,
        },
      },
      lineStyle: {
        normal: {
          width: 8,
        },
      },
      symbolSize: 20,
      data: [
        3.2598,
        3.1811,
        3.7795,
        3.874,
        3.6535,
        3.5433,
        3.5748,
        3.5276,
        3.4488,
      ],
    },
  ],
};
